import { capitalCase, kebabCase } from 'change-case'

export default {
  kebabCase: kebabCase,
  titleCase: capitalCase,
}
